import React from 'react';
import styled from 'styled-components';
import { Box, Typography } from '@material-ui/core';

import { TStoreAddress, TStoreCity, TDistance } from '../../types';
import { Row } from '../Row';
import { displayDistance } from '../../utils';
import { colors } from '../../constants';

interface IProps {
    address: TStoreAddress;
    city: TStoreCity;
    className?: string;
    distanceKm?: TDistance;
    hideDistance?: boolean;
}

const BaseAddressDetails: React.FC<IProps> = ({
    address,
    city,
    className,
    distanceKm,
    hideDistance,
}) => (
    <div className={className}>
        <Row>
            <Box>
                <Typography className="city" color="primary">
                    {city}
                </Typography>
                {distanceKm !== undefined && !hideDistance && (
                    <span>{displayDistance(distanceKm)}</span>
                )}
                <Typography className="address">{address}</Typography>
            </Box>
        </Row>
    </div>
);

interface IStyledProps {
    borderBottom?: boolean;
}

export const AddressDetails = styled(BaseAddressDetails)<IStyledProps>`
    .city {
        font-weight: 800;
        margin-bottom: 3px;
    }

    .city,
    .address {
        font-size: 1.6rem;
    }

    ${Row} {
        justify-content: space-between;

        span {
            color: ${colors.greyDark};
            font-size: 14px;
        }
    }
`;
